<template>
    <div>
        <section class="content-blocks">
            <div class="row no-gutters">
                <div class="block block--slider col-md-6 text-center">
                    <carousel ref="carousel" :per-page="1" :pagination-enabled="false" :mouse-drag="false" class="slider">
                        <slide v-for="slide in slides" :key="slide.slug">
                            <img v-bind:src="'/assets/' + slide.image" v-bind:alt="'Image '+ slide.name "/>
                        </slide>
                    </carousel>
                </div>
                <div class="block block--slider--nav col-md-6 bg-dark">
                    <div class="content" data-aos="fade-up">
                        <h3>Not just wine</h3>
                        <a v-for="(slide, index) in slides" v-bind:class="['h2', {'active' : slide.slug === activeSlide }]" :key="slide.slug" v-on:click="navigateCarousel(index, slide.slug)">
                            {{slide.name}}
                        </a>
                        <router-link ref="link" :to="{ name: 'products', query: { type: activeSlide }}" class="cta" title="Link: Products">
                            Shop other products
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {Carousel, Slide} from 'vue-carousel';

    export default {
        name: 'ProductSliderBlock',
        data() {
            return {
                activeSlide: 'beer',
                slides: []
            };
        },
        components: {
            Carousel,
            Slide
        },
        methods: {
            navigateCarousel: function(index, slug) {
                this.$refs.carousel.goToPage(index);
                this.activeSlide = slug;
            }
        },
        created: function () {
            this.slides = [
                {
                    name: 'Beer',
                    slug: 'beer',
                    image: 'products-beer.jpg',
                },
                {
                    name: 'Spirits',
                    slug: 'spirits',
                    image: 'products-spirits.jpg'
                },
                {
                    name: 'Gifts',
                    slug: 'gift',
                    image: 'products-gifts.jpg'
                },
                {
                    name: 'Fortified Wine',
                    slug: 'fortified-wine',
                    image: 'products-fortified.jpg'
                }
            ]
        }
    }
</script>

<style>
    .VueCarousel-slide{
        position: relative;
    }
</style>
